import { SerializedStyles } from '@emotion/react';
import React, { ReactNode } from 'react';
import { RegisterOptions } from 'react-hook-form';
import { css } from 'twin.macro';
import { FieldFooterV2, IFieldFooterV2Props } from './field-footer-v2.component';
import { FieldLabelV2, IFieldLabelV2Props } from './field-label-v2.component';
import { FieldSubTextV2, IFieldSubTextV2Props } from './field-sub-text-v2.component';

export interface IFieldV2Props<T = unknown, TName = string> extends Pick<RegisterOptions, 'validate'> {
    tooltip?: string;
    name: TName;
    label?: ReactNode;
    subText?: ReactNode;
    required?: boolean;
    value?: T;
    defaultValue?: T;
    placeholder?: string;
    helperText?: ReactNode;
    errorMessage?: ReactNode;
    readOnly?: boolean;
    size?: 'default' | 'small' | 'xxl';
    onLabelClick?: () => void;
    getCustomErrorMessage?: (opts: RegisterOptions) => RegisterOptions;
}

interface IProps<TName> extends IFieldFooterV2Props, IFieldLabelV2Props, IFieldSubTextV2Props {
    className?: string;
    name: IFieldV2Props<TName>['name'];
    children?: ReactNode;
    labelCss?: SerializedStyles;
}

// antd have similar component but this component use with antd-form (rc-field-form) https://github.com/react-component/field-form (this library has limitations)
export function FieldV2<TName>({
    children,
    onLabelClick,
    htmlFor,
    className,
    labelCss,
    ...rest
}: IProps<TName>): JSX.Element {
    const { label, subText } = rest;
    return (
        <div className={className} data-testid={`field-${rest.name}`} css={styles.field}>
            {(label || subText) && (
                <div tw="pb-1.5">
                    {label && <FieldLabelV2 htmlFor={htmlFor} {...rest} onLabelClick={onLabelClick} css={labelCss} />}
                    {subText && <FieldSubTextV2 subText={subText} />}
                </div>
            )}
            {children}
            <FieldFooterV2 {...rest} />
        </div>
    );
}

const styles = {
    field: css`
        width: 100%;
    `,
};
